module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "defaultModal",
      "hide-footer": "",
      "centered": ""
    }
  }, [(_vm.action.action === 'zoomer') ? _c('Zoomer', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-015cba51","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/modal/Modal.vue
// module id = 2975
// module chunks = 0